import React from 'react';

const JoinLeaveTopic = () => {
    return (
        <div className="p-4">
            <h2 className="text-xl font-bold mb-2">Join / Leave Topic</h2>
            {/* Join/Leave controls */}
        </div>
    );
};

export default JoinLeaveTopic;
